/**
 * @flow
 * @relayHash 9e4ee7e4a8ff1a06e168d55408a8743a
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type EventSummaryContainer_node$ref = any;
type EventSummaryContainer_viewer$ref = any;
export type EventRoutes_EventSummary_QueryVariables = {|
  id: string
|};
export type EventRoutes_EventSummary_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: EventSummaryContainer_viewer$ref
  |},
  +node: ?{|
    +$fragmentRefs: EventSummaryContainer_node$ref
  |},
|};
export type EventRoutes_EventSummary_Query = {|
  variables: EventRoutes_EventSummary_QueryVariables,
  response: EventRoutes_EventSummary_QueryResponse,
|};
*/


/*
query EventRoutes_EventSummary_Query(
  $id: ID!
) {
  viewer {
    ...EventSummaryContainer_viewer
    id
  }
  node(id: $id) {
    __typename
    ...EventSummaryContainer_node
    id
  }
}

fragment EventSummaryContainer_viewer on User {
  id
  past_referral_sources
  ...ContactSearchContainer_viewer
  ...ScheduleContainer_viewer
}

fragment EventSummaryContainer_node on Event {
  id
  user_event {
    id
    notes
    referral_source
    ...ScheduleContainer_node
  }
  user_contacts(first: 99999) {
    edges {
      id
      role
      node {
        id
        first_name
        last_name
        company_name
        user_contact_addresses(first: 99999) {
          edges {
            node {
              id
              label
              line1
              line2
              city
              province
              postal_code
              country
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        user_contact_emails(first: 99999) {
          edges {
            node {
              id
              label
              address
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        user_contact_phones(first: 99999) {
          edges {
            node {
              id
              label
              number
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ScheduleContainer_node on UserEvent {
  id
  user_event_segments(first: 99999) {
    edges {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ContactSearchContainer_viewer on User {
  user_contact_search(first: 3, query: "") {
    edges {
      node {
        id
        first_name
        last_name
        user_contact_emails {
          edges {
            node {
              address
              id
            }
          }
        }
        user_contact_phones {
          edges {
            node {
              number
              id
            }
          }
        }
      }
    }
  }
}

fragment ScheduleContainer_viewer on User {
  id
  s_time_zone
  ...AvailabilityCalendarContainer_viewer
}

fragment AvailabilityCalendarContainer_viewer on User {
  s_time_zone
  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: [SHOW], booking_status: [BOOKED, INITIAL, CANCELED], return_empty_connection: true) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 99999) {
          edges {
            node {
              title
              start_at
              end_at
              all_day
              location
              room
              id
            }
          }
        }
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "first_name",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "last_name",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "address",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "number",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "Literal",
  "name": "first",
  "value": 99999,
  "type": "Int"
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "start_at",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "end_at",
  "args": null,
  "storageKey": null
},
v11 = [
  v7
],
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "all_day",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "location",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "room",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "notes",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "line1",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "line2",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "city",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "province",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "postal_code",
  "args": null,
  "storageKey": null
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
},
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "label",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "EventRoutes_EventSummary_Query",
  "id": null,
  "text": "query EventRoutes_EventSummary_Query(\n  $id: ID!\n) {\n  viewer {\n    ...EventSummaryContainer_viewer\n    id\n  }\n  node(id: $id) {\n    __typename\n    ...EventSummaryContainer_node\n    id\n  }\n}\n\nfragment EventSummaryContainer_viewer on User {\n  id\n  past_referral_sources\n  ...ContactSearchContainer_viewer\n  ...ScheduleContainer_viewer\n}\n\nfragment EventSummaryContainer_node on Event {\n  id\n  user_event {\n    id\n    notes\n    referral_source\n    ...ScheduleContainer_node\n  }\n  user_contacts(first: 99999) {\n    edges {\n      id\n      role\n      node {\n        id\n        first_name\n        last_name\n        company_name\n        user_contact_addresses(first: 99999) {\n          edges {\n            node {\n              id\n              label\n              line1\n              line2\n              city\n              province\n              postal_code\n              country\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        user_contact_emails(first: 99999) {\n          edges {\n            node {\n              id\n              label\n              address\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        user_contact_phones(first: 99999) {\n          edges {\n            node {\n              id\n              label\n              number\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ScheduleContainer_node on UserEvent {\n  id\n  user_event_segments(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ContactSearchContainer_viewer on User {\n  user_contact_search(first: 3, query: \"\") {\n    edges {\n      node {\n        id\n        first_name\n        last_name\n        user_contact_emails {\n          edges {\n            node {\n              address\n              id\n            }\n          }\n        }\n        user_contact_phones {\n          edges {\n            node {\n              number\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment ScheduleContainer_viewer on User {\n  id\n  s_time_zone\n  ...AvailabilityCalendarContainer_viewer\n}\n\nfragment AvailabilityCalendarContainer_viewer on User {\n  s_time_zone\n  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: [SHOW], booking_status: [BOOKED, INITIAL, CANCELED], return_empty_connection: true) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 99999) {\n          edges {\n            node {\n              title\n              start_at\n              end_at\n              all_day\n              location\n              room\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "EventRoutes_EventSummary_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "EventSummaryContainer_viewer",
            "args": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "EventSummaryContainer_node",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "EventRoutes_EventSummary_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          v2,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "past_referral_sources",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user_contact_search",
            "storageKey": "user_contact_search(first:3,query:\"\")",
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 3,
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "query",
                "value": "",
                "type": "String!"
              }
            ],
            "concreteType": "UserContactConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "UserContactEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserContact",
                    "plural": false,
                    "selections": [
                      v2,
                      v3,
                      v4,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "user_contact_emails",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserContactEmailConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserContactEmailEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "UserContactEmail",
                                "plural": false,
                                "selections": [
                                  v5,
                                  v2
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "user_contact_phones",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserContactPhoneConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserContactPhoneEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "UserContactPhone",
                                "plural": false,
                                "selections": [
                                  v6,
                                  v2
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "s_time_zone",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": "AvailabilityCalendarContainer_user_events",
            "name": "user_events",
            "storageKey": "user_events(booking_status:[\"BOOKED\",\"INITIAL\",\"CANCELED\"],first:99999,return_empty_connection:true,visibility:[\"SHOW\"])",
            "args": [
              {
                "kind": "Literal",
                "name": "booking_status",
                "value": [
                  "BOOKED",
                  "INITIAL",
                  "CANCELED"
                ],
                "type": "[BookingStatus]"
              },
              v7,
              {
                "kind": "Literal",
                "name": "return_empty_connection",
                "value": true,
                "type": "Boolean"
              },
              {
                "kind": "Literal",
                "name": "visibility",
                "value": [
                  "SHOW"
                ],
                "type": "[UserEventVisibility]"
              }
            ],
            "concreteType": "UserEventConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "UserEventEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserEvent",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "event",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Event",
                        "plural": false,
                        "selections": [
                          v2,
                          v8
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "booking_status",
                        "args": null,
                        "storageKey": null
                      },
                      v9,
                      v10,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "user_event_segments",
                        "storageKey": "user_event_segments(first:99999)",
                        "args": v11,
                        "concreteType": "UserEventSegmentConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserEventSegmentEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "UserEventSegment",
                                "plural": false,
                                "selections": [
                                  v8,
                                  v9,
                                  v10,
                                  v12,
                                  v13,
                                  v14,
                                  v2
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      v2
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [
          v15,
          v2,
          {
            "kind": "InlineFragment",
            "type": "Event",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user_event",
                "storageKey": null,
                "args": null,
                "concreteType": "UserEvent",
                "plural": false,
                "selections": [
                  v2,
                  v16,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "referral_source",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user_event_segments",
                    "storageKey": "user_event_segments(first:99999)",
                    "args": v11,
                    "concreteType": "UserEventSegmentConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserEventSegmentEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserEventSegment",
                            "plural": false,
                            "selections": [
                              v17,
                              v2,
                              v9,
                              v10,
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "time_zone",
                                "args": null,
                                "storageKey": null
                              },
                              v12,
                              v13,
                              v8,
                              v18,
                              v19,
                              v20,
                              v21,
                              v14,
                              v16,
                              v15
                            ]
                          },
                          v22
                        ]
                      },
                      v23
                    ]
                  },
                  {
                    "kind": "LinkedHandle",
                    "alias": null,
                    "name": "user_event_segments",
                    "args": v11,
                    "handle": "connection",
                    "key": "ScheduleContainer_user_event_segments",
                    "filters": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user_contacts",
                "storageKey": "user_contacts(first:99999)",
                "args": v11,
                "concreteType": "EventUserContactConnectionWithRole",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EventUserContactEdge",
                    "plural": true,
                    "selections": [
                      v2,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "role",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserContact",
                        "plural": false,
                        "selections": [
                          v2,
                          v3,
                          v4,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "company_name",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user_contact_addresses",
                            "storageKey": "user_contact_addresses(first:99999)",
                            "args": v11,
                            "concreteType": "UserContactAddressConnection",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "UserContactAddressEdge",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "node",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "UserContactAddress",
                                    "plural": false,
                                    "selections": [
                                      v2,
                                      v24,
                                      v17,
                                      v18,
                                      v19,
                                      v20,
                                      v21,
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "country",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      v15
                                    ]
                                  },
                                  v22
                                ]
                              },
                              v23
                            ]
                          },
                          {
                            "kind": "LinkedHandle",
                            "alias": null,
                            "name": "user_contact_addresses",
                            "args": v11,
                            "handle": "connection",
                            "key": "EventSummaryContainer_user_contact_addresses",
                            "filters": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user_contact_emails",
                            "storageKey": "user_contact_emails(first:99999)",
                            "args": v11,
                            "concreteType": "UserContactEmailConnection",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "UserContactEmailEdge",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "node",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "UserContactEmail",
                                    "plural": false,
                                    "selections": [
                                      v2,
                                      v24,
                                      v5,
                                      v15
                                    ]
                                  },
                                  v22
                                ]
                              },
                              v23
                            ]
                          },
                          {
                            "kind": "LinkedHandle",
                            "alias": null,
                            "name": "user_contact_emails",
                            "args": v11,
                            "handle": "connection",
                            "key": "EventSummaryContainer_user_contact_emails",
                            "filters": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user_contact_phones",
                            "storageKey": "user_contact_phones(first:99999)",
                            "args": v11,
                            "concreteType": "UserContactPhoneConnection",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "UserContactPhoneEdge",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "node",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "UserContactPhone",
                                    "plural": false,
                                    "selections": [
                                      v2,
                                      v24,
                                      v6,
                                      v15
                                    ]
                                  },
                                  v22
                                ]
                              },
                              v23
                            ]
                          },
                          {
                            "kind": "LinkedHandle",
                            "alias": null,
                            "name": "user_contact_phones",
                            "args": v11,
                            "handle": "connection",
                            "key": "EventSummaryContainer_user_contact_phones",
                            "filters": null
                          },
                          v15
                        ]
                      },
                      v22
                    ]
                  },
                  v23
                ]
              },
              {
                "kind": "LinkedHandle",
                "alias": null,
                "name": "user_contacts",
                "args": v11,
                "handle": "connection",
                "key": "EventSummaryContainer_user_contacts",
                "filters": null
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'db1e1792d4c17987d195756f15ccb17b';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/routes/__generated__/EventRoutes_EventSummary_Query.graphql.js